import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models/card-table-options.model';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { CardTableAction } from 'libs/portal/src/modules/tools/card-table/models';
import { Router } from '@angular/router';
import { Endpoints } from '@huge-monorepo/portal/config';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { CardTableComponent } from 'libs/portal/src/modules/tools/card-table/components';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { MemoryService } from 'libs/portal/src/services/memory/memory.service';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { LocationRadiusModalComponent } from '../../../components/location-radius-modal/location-radius-modal/location-radius-modal.component';
import { Routes } from '@huge-monorepo/portal/config';
import { Subscription } from 'rxjs';
import { GenericTableHeaderOptions, RefreshData } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';
import { MatDialog } from '@angular/material/dialog';

export interface Device {
  id: number;
  name: string;
  data: string;
  status: string;
  selected: boolean;
  color: string;
}

@Component({
  selector: 'app-keep-alive',
  templateUrl: './keep-alive.component.html',
  styleUrls: ['./keep-alive.component.scss'],
})
export class KeepAliveComponent implements OnInit, OnDestroy {
  @ViewChild('sticky') sticky: TemplateRef<any>;
  @ViewChild('KATable', { static: false }) public KATable: CardTableComponent;

  keepAliveData: any[] = [];
  deviceIds: number[] = [];
  ScreenSize = ScreenSize;

  totalKeepAliveDevices: number;
  loadingKADevices = false;
  orderKABy = 'TerminalID';
  kaTableCount = 10;
  kaSearch = '';
  kaTableOffset = 0;
  currentKAPage = 1;
  kaDesc = false;

  kaRights: string[] = [];

  firstLoad = true;
  firstKALoad = true;
  obfuscateData = false;
  authSubscription: Subscription;
  getKeepAliveDevicesRequestBody: any = {
    Online: null,
    Terminals: [],
    Merchants: [],
    CDRDeviceNums: [],
    GroupID: null,
  };

  constructor(
    private titleService: TitleService,
    private navigationService: NavigationService,
    public layoutService: LayoutService,
    private genericService: GenericService,
    private paginationService: PaginationService,
    private dialog: MatDialog,
    private router: Router,
    private endpoints: Endpoints,
    private tools: ToolsService,
    private auth: UserRightsService,
    private memory: MemoryService,
    private routeDictionary: Routes,
  ) { }

  kaHeaderOptions: GenericTableHeaderOptions = {
    ShowSearch: true,
    SearchPlaceholder: 'Search Keep Alive Devices',
    DefaultDesc: false,
    DefaultSort: 'TerminalID',
    SortItems: [
      {
        Name: 'TerminalID',
        Display: 'Terminal ID',
      },
      {
        Name: 'CDRDeviceID',
        Display: 'CDR Device',
      },
      {
        Name: 'MerchantName',
        Display: 'Merchant',
      },
      {
        Name: 'TerminalType',
        Display: 'Type',
      },
      {
        Name: 'RingfenceRadius',
        Display: 'Ringfence',
      },
    ],
    FilterItems: [
      {
        Name: 'Terminal',
      },
      {
        Name: 'Merchant',
      },
      {
        Name: 'CDR Device Number',
      },
      {
        Name: 'Status',
        Values: ['Online', 'Offline'],
      },
    ],
  };

  keepAliveTableOptions: CardTableOptions = {
    titleProperty: 'terminalid',
    subTitleProperty: 'terminalType',
    additionalProperty: 'acquiringBank',
    rowId: 'id',
    contentProperty: 'keepAliveServerName',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['color', 'selected', 'id', 'cdrdevice_id'],
    stylePropertyPrefix: 'keepAliveDevices',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  keepAliveTableHeaders: CardTableHeader[] = [];

  locationKeepAliveTableHeaders: CardTableHeader[] = [
    {
      ID: 'terminalid',
      Text: 'Terminal ID',
      Width: 8,
    },
    {
      ID: 'deviceNum',
      Text: 'CDR Device',
      Width: 12,
    },
    {
      ID: 'imei',
      Text: 'IMEI',
      Width: 8,
    },
    {
      ID: 'merchant',
      Text: 'Merchant',
      Width: 20,
    },
    {
      ID: 'terminalType',
      Text: 'Type',
      Width: 8,
    },
    {
      ID: 'ringfence',
      Text: 'Ringfence',
      Width: 10,
    },
    {
      ID: 'currentLocation',
      Text: 'Current Location',
      Width: 12,
    },
    {
      ID: 'distanceFromRingfence',
      Text: 'Distance From Ringfence',
      Width: 12,
    },
  ];

  bothKeepAliveTableHeaders: CardTableHeader[] = [
    {
      ID: 'terminalid',
      Text: 'Terminal ID',
      Width: 8,
    },
    {
      ID: 'deviceNum',
      Text: 'CDR Device',
      Width: 10,
    },
    {
      ID: 'imei',
      Text: 'IMEI',
      Width: 8,
    },
    {
      ID: 'merchant',
      Text: 'Merchant',
      Width: 12,
    },
    {
      ID: 'terminalType',
      Text: 'Type',
      Width: 4,
    },
    {
      ID: 'ringfence',
      Text: 'Ringfence',
      Width: 8,
    },
    {
      ID: 'currentLocation',
      Text: 'Current Location',
      Width: 12,
    },
    {
      ID: 'distanceFromRingfence',
      Text: 'Distance From Ringfence',
      Width: 12,
    },
    {
      ID: 'tlsEnabled',
      Text: 'TLS',
      Width: 4,
      Wrapper: (data) => {
        console.log(data);

        return data ? 'Yes' : 'No';
      }
    }
  ]

  tlsKeepAliveTableHeaders: CardTableHeader[] = [
    {
      ID: 'terminalid',
      Text: 'Terminal ID',
      Width: 12,
    },
    {
      ID: 'terminalSerial',
      Text: 'Terminal Serial',
      Width: 12,
    },
    {
      ID: 'deviceNum',
      Text: 'CDR Device',
      Width: 12,
    },
    {
      ID: 'terminalType',
      Text: 'Type',
      Width: 8,
    },
    {
      ID: 'comms',
      Text: 'Comms',
      Width: 10,
    },
    {
      ID: 'tlsEnabled',
      Text: 'TLS',
      Width: 8,
    }
  ]

  keepAliveRowActions: CardTableAction[] = [
    {
      title: 'View',
      iconSrc: 'assets/icon/eye-outline.svg',
      color: 'primary',
      showIcon: true,
    },
  ];

  async openLocationRadiusModal() {
    const style: string = this.layoutService.screenSize > this.ScreenSize.MOBILE_L ? 'auto-height' : '';

    const dialogRef = this.dialog.open(LocationRadiusModalComponent, {
      data: { deviceIds: this.deviceIds },
    });
  }

  setKATableToRefreshing() {
    setTimeout(() => {
      if (this.KATable) {
        this.KATable.StartRefresh();
      }
    });
  }

  setKATableToFinished() {
    setTimeout(() => {
      if (this.KATable) {
        this.KATable.EndRefresh();
      }
    });
  }

  refreshTable(data: RefreshData): void {
    this.getKeepAliveDevicesRequestBody.Merchants = data.Filters.filter((elem) => elem.Name == 'Merchant' && elem.value != null)?.map((elem) => elem.value);
    this.getKeepAliveDevicesRequestBody.Terminals = data.Filters.filter((elem) => elem.Name == 'Terminal' && elem.value != null)?.map((elem) => elem.value);
    this.getKeepAliveDevicesRequestBody.CDRDeviceNums = data.Filters.filter((elem) => elem.Name == 'CDR Device Number' && elem.value != null)?.map((elem) => elem.value);
    if (this.getKeepAliveDevicesRequestBody.Merchants == null) {
      this.getKeepAliveDevicesRequestBody.Merchants = [];
    }
    if (this.getKeepAliveDevicesRequestBody.Terminals == null) {
      this.getKeepAliveDevicesRequestBody.Terminals = [];
    }
    if (this.getKeepAliveDevicesRequestBody.CDRDeviceNums == null) {
      this.getKeepAliveDevicesRequestBody.CDRDeviceNums = [];
    }
    this.getKeepAliveDevicesRequestBody.Online =
      data.Filters.find((elem) => elem.Name == 'Status')?.value != null ? (data.Filters.find((elem) => elem.Name == 'Status')?.value == 'Online' ? true : false) : null;
    this.orderKABy = data.Sort ?? '';
    this.kaSearch = data.Search ?? '';
    this.kaDesc = data.Desc ?? this.kaDesc;
    this.kaTableOffset = 0;
    this.currentKAPage = 1;
    this.getKeepAliveDevices(this.orderKABy, this.kaSearch, this.kaTableCount, this.kaTableOffset, this.kaDesc);
  }

  getKeepAliveDevices(orderBy: string, search: string, count: number, offset: number, desc: boolean) {
    this.loadingKADevices = true;
    this.setKATableToRefreshing();
    this.genericService.POST(this.endpoints.GET_KEEP_ALIVE_DEVICES(search, count, offset, orderBy, desc), this.getKeepAliveDevicesRequestBody).subscribe(
      (resp: Object) => {
        const deviceData = resp['body'];
        const tmpData: any = [];
        if (deviceData != null && deviceData.length > 0) {
          deviceData.forEach((element: any) => {
            const ringfenceRadius = element.RingfenceRadius != null ? element.RingfenceRadius / 1000 + ' km' : '';
            const acceptedLocation =
              element.AcceptedLocation != null &&
                element.AcceptedLocation.lat != null &&
                element.AcceptedLocation.lng != null &&
                element.AcceptedLocation.lng != 0 &&
                element.AcceptedLocation.lat != 0
                ? '(Known)'
                : '(Unknown)';
            const currentLocation =
              element.CurrentLocation != null &&
                element.CurrentLocation.lat != null &&
                element.CurrentLocation.lng != null &&
                element.CurrentLocation.lng != 0 &&
                element.CurrentLocation.lat != 0
                ? '(Known)'
                : '(Unknown)';
            const distanceFromRingfence = ringfenceRadius != '-' && acceptedLocation != '(Unknown)' && currentLocation != '(Unknown)' ? element.DistanceFromRingfence : '-';
            let ob = {
            }
            if (this.kaRights.includes('location') && this.kaRights.includes('tls')) {
              ob = {
                id: element.ID || element.DeviceID,
                terminalid: `${element.TerminalID}`,
                cdrdevice_id: element.CDRDeviceID,
                deviceNum: element.DeviceNum ? element.DeviceNum : '',
                imei: element.IMEI,
                // cdrOnline: { status: element.CDROnline, lastSeen: element.CDRLastSeen },
                // kaOnline: { status: element.KAOnline, lastSeen: element.KALastSeen },
                merchant: element.MerchantName ? (this.obfuscateData ? this.tools.Obfuscate(element.MerchantName, 'Merchant', 8) : element.MerchantName) : '',
                terminalType: element.TerminalType,
                ringfence: ringfenceRadius + ' ' + acceptedLocation,
                currentLocation: currentLocation,
                distanceFromRingfence: distanceFromRingfence != '-' ? this.formatDistance(distanceFromRingfence) : '-',
                tlsEnabled: element.TLSEnabled ? 'Yes' : 'No',
                selected: false,
                // comms: '?',
                color: element.Online ? '#3FC944' : '#C96D01',
              };
            } else if (this.kaRights.includes('location') && !this.kaRights.includes('tls')) {
              ob = {
                id: element.ID || element.DeviceID,
                terminalid: `${element.TerminalID}`,
                cdrdevice_id: element.CDRDeviceID,
                deviceNum: element.DeviceNum ? element.DeviceNum : '',
                imei: element.IMEI,
                merchant: element.MerchantName ? (this.obfuscateData ? this.tools.Obfuscate(element.MerchantName, 'Merchant', 8) : element.MerchantName) : '',
                terminalType: element.TerminalType,
                ringfence: ringfenceRadius + ' ' + acceptedLocation,
                currentLocation: currentLocation,
                distanceFromRingfence: distanceFromRingfence != '-' ? this.formatDistance(distanceFromRingfence) : '-',
                selected: false,
                color: element.Online ? '#3FC944' : '#C96D01',
              };
            } else if (this.kaRights.includes('tls') && !this.kaRights.includes('location')) {
              ob = {
                id: element.ID || element.DeviceID,
                terminalid: `${element.TerminalID}`,
                cdrdevice_id: element.CDRDeviceID,
                terminalSerial: element.Serial,
                deviceNum: element.DeviceNum ? element.DeviceNum : '',
                terminalType: element.TerminalType,
                comms: null ? "Unknown"
                  : this.tools.FormatSwedishDateTime(
                    this.tools.ParseAPIDateWithTimezone(element.KALastSeen),
                  ),
                tlsEnabled: element.TLSEnabled ? 'Yes' : 'No',
                selected: false,
                color: element.Online ? '#3FC944' : '#C96D01',
              };
            }


            tmpData.push(ob);
          });
        }
        this.keepAliveData = tmpData;

        this.totalKeepAliveDevices = this.tools.ExtractPaginationFromHeaders(resp['headers']);

        this.loadingKADevices = false;
        this.setKATableToFinished();
        this.firstKALoad = false;
        this.paginationService.emit();
      },
      () => {
        this.setKATableToFinished();
        this.paginationService.emit();
        this.firstKALoad = false;
        this.loadingKADevices = false;
      },
    );
  }

  getPagedDevices(pageIndex: number) {
    this.kaTableOffset = (pageIndex - 1) * this.kaTableCount;
    this.currentKAPage = pageIndex;
    this.getKeepAliveDevices(this.orderKABy, this.kaSearch, this.kaTableCount, this.kaTableOffset, this.kaDesc);
  }

  ngOnInit() {
    this.keepAliveTableHeaders = this.bothKeepAliveTableHeaders;
    this.kaRights = this.auth.GetKeepAliveTypes();
    if (this.kaRights.includes('location') && this.kaRights.includes('tls')) {
      this.keepAliveTableHeaders = this.bothKeepAliveTableHeaders;

    } else if (this.kaRights.includes('location') && !this.kaRights.includes('tls')) {
      this.keepAliveTableHeaders = this.locationKeepAliveTableHeaders;

    } else if (!this.kaRights.includes('location') && this.kaRights.includes('tls')) {
      this.keepAliveTableHeaders = this.tlsKeepAliveTableHeaders;

    }

    this.titleService.pageTitle = 'Devices';
    this.getKeepAliveDevicesRequestBody.GroupID = this.auth.GetGroupID();
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      this.obfuscateData = user.isObfuscated;
      if (!this.firstLoad) {
        this.getKeepAliveDevices(this.orderKABy, '', this.kaTableCount, this.kaTableOffset, this.kaDesc);
      }
    });

    const memory = this.memory.getDetails();
    if (memory != null && !memory.isCdr) {
      this.getKeepAliveDevices(memory.orderBy, memory.search, memory.tableCount, memory.tableOffset, memory.desc);
      this.kaSearch = memory.search;
    } else {
      this.getKeepAliveDevices(this.orderKABy, '', this.kaTableCount, this.kaTableOffset, this.kaDesc);
      this.kaSearch = '';
    }
  }

  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  formatDistance(distance: number): string {
    if (distance > 1000) {
      return (distance / 1000).toFixed(2) + 'km';
    } else {
      return distance + 'm';
    }
  }

  ngAfterViewInit(): void {
    this.layoutService.addStickyHeaderForRoute(this.navigationService.GetCurrentRoute(), this.sticky);
  }

  onKaAction(event: any) {
    if (event.title == 'View' && event.row != null) {
      this.memory.setDetails(false, this.orderKABy, this.kaSearch, this.kaTableCount, this.kaTableOffset, this.kaDesc);
      this.router.navigate([this.routeDictionary.KeepAliveDeviceDetails], {
        state: {
          data: {
            CdrID: event.row.cdrdevice_id,
            KaID: event.row.id || event.row.DeviceID,
          },
        },
      });
    }
  }

  refreshData(event) {
    setTimeout(() => {
      event.target.complete();
    }, 2000);
  }
}
